import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import mvilla from './imgs/mordenvilla.jpeg';
import hvilla from './imgs/hospital.jpeg';
import eduvilla from './imgs/education.jpeg';
import scivlla from './imgs/sciencelab.jpeg';
import village from './imgs/villagevilla.jpeg';
import grden from './imgs/garden.jpeg';
import cultural from './imgs/cultural.jpeg';
import pvtbk from './imgs/pvtbk.gif';
import axios from 'axios';

import {cleardv} from './clearmem';
import {Useraction} from './Useractions';
import {setusersinactiondv} from './userdefaultdata';

export default class Villactions extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "villa";
	
  	}
	
    state = {

	
        name: "villa",
       respdata: null,   
       url: "",
      vnm:"villa",
      imgurl:mvilla,	
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
        this.setbackurl();
	this.setvilla();

    }
 
setvilla(){
       
         const vn = Usersession.getVillaname();
  	const vid = Usersession.getVillaId();
        if(vid > 0){
         setusersinactiondv(vid,false);
         }
	 this.setState({ vnm: vn });

}
  


  
setbackurl(){
   const vtypeid = Usersession.getVillatype();
    const vtp = parseInt(vtypeid);
   const vid = Usersession.getVillaId();
   if(vtp < 2){
   
   this.setpubvbackground(vid);
   }
  else{
    this.setpvtvbackground(vid);
  }
			
}
setpubvbackground(vid:any){
   if(vid == 1)   this.setState({ imgurl: mvilla });
   else if(vid == 2)   this.setState({ imgurl: village });
   else if(vid == 3)   this.setState({ imgurl: grden });
   else if(vid == 4)   this.setState({ imgurl: mvilla });
   else if(vid == 5)   this.setState({ imgurl: mvilla });
   else if(vid == 6)   this.setState({ imgurl: cultural });
   else if(vid == 7)   this.setState({ imgurl: scivlla });
   else if(vid == 8)   this.setState({ imgurl: hvilla });
   else if(vid == 9)   this.setState({ imgurl: cultural });
   else if(vid == 10)   this.setState({ imgurl: hvilla });
   else this.setState({ imgurl: grden });

}
setpvtvbackground(vid:any){
     this.setState({ imgurl: pvtbk });

}

 render() {
let imageUrl =this.state.imgurl;
   const componentStyle = {
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100%', // Example height
    width: '100%',   // Example width
    zIndex:'25000',	
  };
   
     return (

        
	<div style={componentStyle} id="activity">
         
	 <div id= "chatdives" className="c-txtarea">
          <div className="pr100">  	
	        <div id="useractions" style={{height:'34vh',top:'2vh'}} className="c-action">
		  
		</div>	
		<div style={{width:'87%',left:'6%',zIndex:'31000',position:'fixed'}} className="c-txtcontainer">
		
		
		<input  id="ctxt" type="text" className="cu-txtbox"/>
	     	
	       </div>
            </div>  	
	  </div>
	</div>
   	
    
   
      );
}
}

